"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireWildcard(require("react"));

var _reactSpring = require("react-spring");

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _hooks = require("../hooks");

var _layout = require("../layout");

var _constants = require("./constants");

var _core = require("@emotion/core");

var HideableDiv = (
/*#__PURE__*/
0, _styledBase.default)('div', {
  target: "e1vjef4v0"
})(function (_ref) {
  var isVisible = _ref.isVisible;
  return {
    display: 'flex',
    flexDirection: 'column',
    visibility: isVisible ? 'visible' : 'hidden'
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

var ExpanderContentWithoutDocs = function ExpanderContentWithoutDocs(_ref2) {
  var children = _ref2.children,
      _ref2$isExpanded = _ref2.isExpanded,
      isExpanded = _ref2$isExpanded === void 0 ? _constants.ExpanderContentDefaultProps.isExpanded : _ref2$isExpanded,
      _ref2$spacingTop = _ref2.spacingTop,
      spacingTop = _ref2$spacingTop === void 0 ? _constants.ExpanderContentDefaultProps.spacingTop : _ref2$spacingTop,
      dataTestId = _ref2.dataTestId;

  var _useState = (0, _react.useState)(isExpanded),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isVisible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = (0, _react.useState)(isExpanded),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      isFullyExpanded = _useState4[0],
      setFullyExpanded = _useState4[1];

  var _useResizeObserver = (0, _hooks.useResizeObserver)({
    // If contentHeight isn't calculated yet, use an extremely large maxHeight to
    // prevent content shifting around once it has been calculated. The change
    // won't be visible because this is maxHeight not height, so the expander won't
    // grow bigger than the content anyway.
    defaultHeight: 99999
  }),
      ref = _useResizeObserver.ref,
      contentHeight = _useResizeObserver.height;

  var collapsedStyles = {
    opacity: 0,
    maxHeight: 0
  };
  var expandedStyles = {
    opacity: 1,
    maxHeight: contentHeight
  };
  var styles = isExpanded ? expandedStyles : collapsedStyles;

  var _useSpring = (0, _reactSpring.useSpring)(function () {
    return (0, _objectSpread2.default)({}, styles);
  }),
      _useSpring2 = (0, _slicedToArray2.default)(_useSpring, 2),
      props = _useSpring2[0],
      setSpringProps = _useSpring2[1];

  (0, _react.useEffect)(function () {
    if (isExpanded) {
      // Make content visible before starting the animation, and do nothing after
      // the animation ends (onRest has to be explicitly set because it will be
      // cached with the value below)
      setVisible(true);
      setSpringProps((0, _objectSpread2.default)({}, expandedStyles, {
        onRest: function onRest() {
          setFullyExpanded(true);
        }
      }));
    } else {
      setFullyExpanded(false); // Make the content invisible after the animation ends

      setSpringProps((0, _objectSpread2.default)({}, collapsedStyles, {
        onRest: function onRest() {
          return setVisible(false);
        }
      }));
    }
  }, [isExpanded, expandedStyles, collapsedStyles, setVisible]);
  return (0, _core.jsx)(_reactSpring.animated.div, {
    style: (0, _objectSpread2.default)({}, props, {
      overflow: isFullyExpanded ? 'visible' : 'hidden'
    }),
    "data-test-component": "StencilExpanderContent",
    "data-test-id": dataTestId
  }, (0, _core.jsx)(HideableDiv, {
    ref: ref,
    isVisible: isVisible,
    "aria-hidden": !isVisible
  }, (0, _core.jsx)(_layout.Spacer, {
    height: spacingTop
  }), children));
};

ExpanderContentWithoutDocs.defaultProps = (0, _objectSpread2.default)({}, _constants.ExpanderContentDefaultProps);
var ExpanderContent = (0, _stencilReactDesc.describe)(ExpanderContentWithoutDocs).description('Container which can be collapsed or expanded.');
ExpanderContent.propTypes = {
  children: _stencilReactDesc.PropTypes.node.description('Content to display in the container.'),
  isExpanded: _stencilReactDesc.PropTypes.bool.description('Whether the container should be expanded. If false, the content will not be visible.') // Normally defaults would come from defaultProps automatically but due to a
  // bug in react-desc, defaults that are falsy get ignored.
  .defaultValue(_constants.ExpanderContentDefaultProps.isExpanded),
  spacingTop: _stencilReactDesc.PropTypes.number.description('Spacing in pixels to add above the content at the top of the container.') // Same as above
  .defaultValue(_constants.ExpanderContentDefaultProps.spacingTop),
  dataTestId: _stencilReactDesc.PropTypes.string.description("Sets the 'data-test-id' attribute in the DOM, for testing purposes.")
};
ExpanderContent.displayName = 'ExpanderContent';
var _default = ExpanderContent;
exports.default = _default;